import { render, staticRenderFns } from "./donutHandler.vue?vue&type=template&id=b67b0f4a&"
import script from "./donutHandler.vue?vue&type=script&lang=js&"
export * from "./donutHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports